export const apiOrigin = import.meta.env.DEV
  ? 'http://localhost:8060'
  : 'https://api.grunstack.com';

export const syncOrigin = import.meta.env.DEV
  ? 'http://localhost:8080'
  : 'https://api.grunstack.com';

export const dictionaryCdnOrigin = 'https://d13s2p88qzqpr8.cloudfront.net';

// OAuth client IDs are public identifiers. This can still be overridden for
// alternate deployments without changing source.
export const googleOAuthClientId =
  import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID ??
  '674495661023-qqefa4fc5ochvqdf5j1c2hb9j29ors81.apps.googleusercontent.com';

export const supportedLanguages = [
  { code: 'da', name: 'Danish', flag: '🇩🇰' },
  { code: 'de', name: 'German', flag: '🇩🇪' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸' },
  { code: 'zh-tr', name: 'Chinese (Traditional)', flag: '🇹🇼' },
] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number]['code'];
